import { css } from 'styled-components';
export const Variables = css`
  :root {
    --white: #fff;
    --primary-color: #16cdd9;
    --secundary-color: #395173;
    --light-color: #b7e7e7;
    --tertiary-color: #216cd9;
    --error-color: #ff6347;
  }
`;
